import React from 'react'
import PropTypes from 'prop-types'
import c from 'classnames'
import { propTypes, defaultProps } from './props'

// DEPREACATED
export function NumericText({ className, children, ...props }) {
  return (
    <div className={c('number-text', className)}>
      <input className="form-control" type="text" />
    </div>
  )
}
export default NumericText

NumericText.propTypes = {
  ...propTypes,
  className: PropTypes.string,
  children: PropTypes.node,
}

NumericText.defaultProps = {
  ...defaultProps,
  className: '',
  children: null,
}
